<template>
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; background: rgb(2,0,36);
background: linear-gradient(0deg, rgba(65,102,177,1) 34%, rgba(69,112,199,1) 100%)">
        <el-card class="box-card" style="max-width: 600px; margin: 0 auto; width: 90%; background: #f6f8ff;">
            <div style="font-weight: 700; margin-bottom: 32px;">
                Welcome to Projects Map Manager
            </div>
            <div style="margin-top: 16px;">
                <el-input type="text" placeholder="First name" v-model="userInfo.first_name" required></el-input>
            </div>
            <div style="margin-top: 16px;">
                <el-input type="text" placeholder="Last name" v-model="userInfo.last_name" required></el-input>
            </div>
            <div style="margin-top: 16px;">
                <el-input type="text" placeholder="Company name" v-model="userInfo.company_name" required></el-input>
            </div>
            <div style="margin-top: 16px;">
                <el-input type="email" placeholder="Email" v-model="userInfo.email" required></el-input>
            </div>
            <div style="margin-top: 16px;">
                <el-input type="password" placeholder="Password" v-model="userInfo.password" required></el-input>
            </div>
            <div style="margin-top: 32px; margin-bottom: 32px;">
                <div style="display: flex; align-items: center; flex-direction: row-reverse;">
                    <el-button v-loading="loading" type="primary" @click.native="handleSignup" style="width: 100%;">Sign up</el-button>
                </div>
                <div v-if="errorMessage" style="color: red; margin-top: 10px;">
                    {{errorMessage}}
                </div>
            </div>
            <div style="height: 40px; margin: 16px -20px -20px; background: #e1e6f6;">
                <div style="display: flex;align-items: center; justify-content: space-between; padding: 0 20px;">
                    <router-link to="/login">
                        <div style="line-height: 40px; color: #4570c7;">
                            Log in
                        </div>
                    </router-link>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            loading: false,
            errorMessage: null,
            userInfo: {}
        }
    },
    methods: {
        handleSignup() {
            this.errorMessage = null;
            this.loading = true;
            axios.post('/users', {
                    data: {
                        type: 'users',
                        attributes: this.userInfo
                    }
                })
                .then(response => {
                    axios.post('/auth', {
                            username: this.userInfo.email,
                            password: this.userInfo.password
                        })
                        .then(response => {
                            localStorage.token = response.data.access_token;
                            if (this.$route.query.next) {
                                window.location.href = '/#/login?redirect=' + encodeURIComponent(this.$route.query.next);
                            }
                            else {
                                window.location.href = '/#/projects';
                            }
                            window.location.reload();
                        })
                        .catch(error => {
                            console.log(error);
                            this.errorMessage = 'Could not login with provided credentials'
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                })
                .catch(error => {
                    if (error.response && error.response.status == 409) {
                        this.errorMessage = 'An account with this email already exists. If this is you click Log in.'
                    } else {
                        console.log(error);
                        this.errorMessage = 'An error occured'
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>